import { CLIMATES } from '../components/scene/Weather';

// The visitor's current local weather from /api/local-weather (netlify/functions/local-weather.mjs):
// { climate, place, windFrom, windKmh }. Resolves to null if it isn't available (plain `yarn start`,
// the weather service is down, or it takes too long), so the gallery simply keeps its random start.
export const fetchLocalWeather = async (timeoutMs = 4000) => {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch('/api/local-weather', { signal: ctrl.signal });
    if (!res.ok || !(res.headers.get('content-type') || '').includes('application/json')) return null;
    const data = await res.json();
    return CLIMATES[data.climate] ? data : null;
  } catch (e) {
    return null;
  } finally {
    clearTimeout(timer);
  }
};
